import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Fingerprint } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("كلمتا المرور غير متطابقتين");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("تم تغيير كلمة المرور بنجاح");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl border p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-2xl bg-emerald-900 flex items-center justify-center">
            <Fingerprint className="w-6 h-6 text-amber-400" />
          </div>
          <h1 className="text-lg font-extrabold text-emerald-950">تعيين كلمة مرور جديدة</h1>
        </div>
        {!token ? (
          <p className="text-sm text-rose-700" data-testid="reset-invalid-token">الرابط غير صالح — اطلب رابطاً جديداً من صفحة الاستعادة.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="password">كلمة المرور الجديدة</Label>
              <Input id="password" type="password" dir="ltr" data-testid="reset-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required minLength={6} placeholder="6 أحرف على الأقل" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="confirm">تأكيد كلمة المرور</Label>
              <Input id="confirm" type="password" dir="ltr" data-testid="reset-confirm-input" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} required placeholder="أعد كتابة كلمة المرور" />
            </div>
            {error && (
              <div data-testid="reset-error-alert"
                className="text-sm bg-rose-50 text-rose-700 border border-rose-200 rounded-lg px-3 py-2">
                {error}
              </div>
            )}
            <Button type="submit" data-testid="reset-submit-button" disabled={loading}
              className="w-full bg-emerald-900 hover:bg-emerald-950 text-white h-11">
              {loading ? "جارٍ الحفظ..." : "حفظ كلمة المرور الجديدة"}
            </Button>
          </form>
        )}
        <p className="text-center mt-4">
          <Link to="/login" className="text-sm text-emerald-800 hover:underline">العودة لتسجيل الدخول</Link>
        </p>
      </div>
    </div>
  );
}
